import React, { useEffect, useState } from 'react';
import FlatpickrField from '../../Components/FlatpickrField';
import { CommonUtil } from '../../utils/CommonUtil';
import { NetworkManager } from '../../Components/NetworkManager';
import BusyLoader from '../../Components/BusyLoader';
import CheckAvailabilityPreview from './CheckAvailabilityPreview';
import ToastManager from '../../Components/ToastManager';

const EditReservDates = ({ startDate, endDate, onSave, onCancel, reservationId }: any) => {
    const [newStartDate, setNewStartDate] = useState(CommonUtil.getDateFormatForDatePicker(startDate));
    const [newEndDate, setNewEndDate] = useState(CommonUtil.getDateFormatForDatePicker(endDate));
    const [allInvoices, setAllInvoices] = useState<any>([]);

    let onLoginError = (err: any) => {
        BusyLoader.hideLoader();
        ToastManager.showToast("An error occurred. Please try again.", "Error");
    }

    useEffect(() => {
        getAllInvoice();
    }, []);

    useEffect(() => {
        console.log(allInvoices, "allInvoices");
    }, [allInvoices]);
    
    const getAllInvoice = () => {
        BusyLoader.showLoader();
        const apiUrl = `api/reservation/allInvoice/preview?reservationId=${reservationId}`;
        NetworkManager.sendJsonRequest(apiUrl, "", "", "GET", true, onSuccessAllInvoice, onLoginError);
    };
    
    const onSuccessAllInvoice = (response: any) => {
        BusyLoader.hideLoader();
        const restData = CommonUtil.parseData(response);
        if (!restData) return;

        const allInvoices = [
        ...(restData || []),
        ];
        setAllInvoices(allInvoices);
    }

    const getFormattedDate = (date: any) => {
        if (!date) return "";
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const handlePreview = (startDate: any) => {
        if (startDate) {
            const formattedDate = getFormattedDate(startDate);
            BusyLoader.showLoader();
            const apiUrl = `api/reservation/backdate/preview?reservationId=${reservationId}&backdateStart=${formattedDate}`;
            NetworkManager.sendJsonRequest(apiUrl, "", "", "GET", true, (response: any) => {
                BusyLoader.hideLoader();
                const previewData = CommonUtil.parseData(response);
                if (previewData) {
                    setAllInvoices((prevValue: any) => {
                        // Filter out previous preview items if any
                        const nonPreviewItems = prevValue.filter((item: any) => !item.isPreview);
                        const newItems = Array.isArray(previewData) ? previewData : [previewData];
                        const flaggedItems = newItems.map((item: any) => ({ ...item, isPreview: true }));
                        return [...flaggedItems, ...nonPreviewItems];
                    });
                }
            }, (err: any) => {
                BusyLoader.hideLoader();
                onLoginError(err);
            });
        }
    };

    const onStartDateChange = (date: any) => {
        const selectedDate = date[0];
        setNewStartDate(selectedDate);
        handlePreview(selectedDate);
    };

    const handleSave = () => {
        const formattedDate = getFormattedDate(newStartDate);
        
        BusyLoader.showLoader();
        const apiUrl = `api/reservation/backdate/inv?resId=${reservationId}&backdateStart=${formattedDate}`;
        
        NetworkManager.sendJsonRequest(apiUrl, "", "", "POST", true, (response: any) => {
            BusyLoader.hideLoader();
            const restData = CommonUtil.parseData(response);
            console.log("Save Response:", restData);
            
            if (restData?.success === true) {
                ToastManager.showToast(restData?.message || "Reservation dates updated successfully", "Success");
                onSave();
            } else {
                ToastManager.showToast(restData?.errorMessage || "Failed to update reservation dates", "Error");
            }
        }, onLoginError);
    };

    return (
        <div className="d-flex flex-column" style={{ height: "calc(100vh - 80px)", margin: "-16px" }}>
            {/* Top section: Date selection */}
            <div className="p-3 bg-white border-bottom shadow-sm">
                <div className="row align-items-center">
                    <div className="col-md-6 my-1">
                        <FlatpickrField
                            placeholder="Reservation Start Date"
                            value={newStartDate}
                            onChange={onStartDateChange}
                            options={{
                                dateFormat: CommonUtil.DATE_FORMAT.dateFormat,
                                // maxDate: CommonUtil.getDateFormatForDatePicker(startDate)
                            }}
                        />
                    </div>
                    <div className="col-md-6 my-1">
                        <FlatpickrField
                            placeholder="Reservation End Date"
                            value={newEndDate}
                            onChange={(date: any) => setNewEndDate(date[0])}
                            options={{
                                dateFormat: CommonUtil.DATE_FORMAT.dateFormat,
                            }}
                            disabled
                        />
                    </div>
                </div>
            </div>

            {/* Middle section: Scrollable list */}
            <div className="flex-grow-1 overflow-auto bg-light px-3">
                {allInvoices.length > 0 ? (
                    <CheckAvailabilityPreview data={allInvoices} defaultCollapsed={true} />
                ) : (
                    <div className="text-center py-5 mt-5">
                        <h5 className="text-muted">No invoices found for this reservation.</h5>
                    </div>
                )}
            </div>

            {/* Bottom section: Footer */}
            <div className="modal-footer bg-white border-top justify-content-end p-3" style={{ position: "sticky", bottom: 0, width: "100%", zIndex: 10 }}>
                <button type="button" className="col-1 btn btn-outline-success btn-lg px-5 mx-2" onClick={onCancel}>
                    Cancel
                </button>
                <button type="button" className="col-1 btn btn-success btn-lg px-5 ms-2 me-4" onClick={handleSave} >
                    Save
                </button>
            </div>
        </div>
    );
};

export default EditReservDates;
